import script from "./campaignProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./campaignProgress.vue?vue&type=script&setup=true&lang=js"

import "./campaignProgress.vue?vue&type=style&index=0&id=d20426a4&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d20426a4"]])

export default __exports__